import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import banner from './assets/banner/banner.png';
import About from './components/About/About';
import Techstack from './components/Techstack/Techstack';
import Projects from './components/Projects/Projects';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className='app'>
      <Navbar />
      <img src={banner} alt="Banner" className="banner" />
      <About />
      <Techstack />
      <Projects />
      <Footer />
    </div>
  );
}

export default App;
